import {GridLayout, GridLayoutItem} from "@progress/kendo-react-layout";
import React from 'react';
import './Footer.scss';


const Footer = () => {
  let copyRightText = `Copyright © ${(new Date()).getFullYear()} State of Nebraska`;

    return (
      <div className='footer wrap-container'>
        <div className='row top-footer'>
          <div className='footer-container'>
            <GridLayout
              align={{ horizontal: 'stretch' }}
              rows={[{ height: 'auto' }]}
              cols={[{ width: '50%' }, { width: '50%' }]}
              gap={{ rows: 5, cols: 5 }}
            >
              <GridLayoutItem col={1} row={1} className='footer-left'>
                <section id='block-block-4' className='block block-block clearfix'>
                  <p>
                    <strong>Nebraska Rules and Regulations</strong>
                    <br />
                    <span className='sr-only'>Phone</span>
                    <i aria-hidden="true" className='fa fa-phone' />402.471.2385
                    <br />
                    <span className='sr-only'>Fax</span>
                    <i aria-hidden="true" className='fa fa-print' />402.471.2530
                    <br />
                    <span style={{whiteSpace: 'nowrap'}}>
                      <span className='sr-only'>Email</span>
                      <i aria-hidden="true" className='fa fa-envelope' />sos.regulations@nebraska.gov
                    </span>
                  </p>
                  <p>
                    <strong>Mailing Address</strong>
                    <br />
                    P.O. Box 94608
                    <br />
                    Lincoln, NE 68509-4608
                  </p>
                  <p>
                    <strong>Street Address</strong>
                    <br />
                    1201 N Street, Suite 120
                    <br />
                    Lincoln, NE 68508
                  </p>
                </section>
              </GridLayoutItem>
              <GridLayoutItem col={2} row={1} className='footer-right'>
                <div className='col-xs-12 col-sm-12 col-md-12 third-col-footer'>
                  <div id='branding'>
                    <p>
                      Powered by{' '}
                      <a
                        className='powered-by'
                        href='http://www.tecuity.com'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Tecuity, Inc.
                      </a>
                    </p>
                    <p>{copyRightText}</p>
                  </div>
                </div>
              </GridLayoutItem>
            </GridLayout>
          </div>
        </div>
      </div>
    );
}

export default Footer